export const POPUP_LABEL = {
  HEADER: $localize`Add Shipper Configuration`,
  EDIT_HEADER: $localize`Edit Shipper Configuration`,

  LOCATION: $localize`Location`,
  ADDRESS: $localize`Address`,
  GROUPS: $localize`Group`,
  CONFIGURATIONS: $localize`configurations`,
  CLOSE_MODAL: {
    HEADER: $localize`Close Window`,
    BODY:
      $localize`Are you sure you want to close the window?` +
      ' ' +
      $localize`Your changes will not be saved.`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};

export const FORM_CONSTANTS = {
  TIMEZONE: $localize`Time Zone`,
  ORIGIN_SORT: $localize`Origin Sort`,
  DESTINATION_SORT: $localize`Dest Sort`,
  SERVICE_LEVEL: $localize`Service Level`,
};
